<div class="beneficios-clube-container">
  <div class="beneficios-clube-header">
    <img [src]="'images/ifood-landing/club.svg' | assetsUrl" alt="Clube" class="icon-clube" />
    <span class="beneficios-clube-title">
        <ng-container *ngIf="isClube">Meus descontos Clube iFood</ng-container>
        <ng-container *ngIf="!isClube">Descontos Clube iFood</ng-container>
      </span>
  </div>
  <div class="beneficios-clube-subtitulo">
    <ng-container *ngIf="isClube">Preços diferenciados só pra você que é Clube</ng-container>
    <ng-container *ngIf="!isClube">Assine o Clube iFood e desbloqueie esses benefícios</ng-container>
  </div>
  <div *ngIf="isClube" class="beneficios-clube-alerta">
    <img [src]="'images/ifood-landing/checkmark-clube.svg' | assetsUrl" alt="Clube" class="icon-clube" />
    Descontos já aplicados e prontinhos para usar
  </div>
  <div class="beneficios-clube-items">
    <ng-container *ngFor="let benefit of clubBenefits">
      <div class="beneficios-clube-item-white-box">
        <ng-container *ngIf="isClube">
          <div class="beneficios-clube-item">
            <img [src]="benefit.icon | assetsUrl" [alt]="benefit.subtitle" class="beneficios-clube-icon" />
            <div class="beneficios-clube-item-title">{{ benefit.title }}</div>
            <div class="beneficios-clube-item-subtitle">{{ benefit.subtitle }}</div>
            <button class="beneficios-clube-aproveitar" (click)="benefit.clickHandler()">Aproveitar</button>
          </div>
        </ng-container>
        <ng-container *ngIf="!isClube">
          <div class="beneficios-clube-points-lock-circle">
            <img [src]="'images/ifood-landing/points-lock.svg' | assetsUrl" [alt]="benefit.lockAlt" class="beneficios-clube-points-lock" />
          </div>
          <div class="beneficios-clube-item">
            <img [src]="benefit.iconGris | assetsUrl" [alt]="benefit.subtitle" class="beneficios-clube-icon" />
            <div class="beneficios-clube-item-title-gris">{{ benefit.titleGris }}</div>
            <div class="beneficios-clube-item-subtitle">{{ benefit.subtitle }}</div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!isClube">
    <button class="beneficios-clube-btn" (click)="onClubeWantMemberClick()">Quero ser Clube iFood</button>
    <button class="beneficios-clube-ja-sou" (click)="onClubIfoodClick()">Já sou Clube iFood</button>
  </div>
</div>
